import React from "react";
import { Link } from "react-router-dom";

function HomeTile({
  id,
  title,
  icon: Icon,
  to,
  disabled = false,
  badge,
  className = "span3",
}) {
  const titleLines = Array.isArray(title) ? title : [title];
  const isClickable = Boolean(to) && !disabled;

  const content = (
    <>
      <h3>
        {titleLines.map((line, index) => (
          <React.Fragment key={line}>
            {index > 0 && <br />}
            {line}
          </React.Fragment>
        ))}
      </h3>
      {badge != null && <div className="circle-indicator">{badge}</div>}
      {Icon && (
        <Icon className="home-tile-icon" size={28} strokeWidth={1.75} aria-hidden="true" />
      )}
    </>
  );

  return (
    <li id={id} className={`${className}${disabled ? " disabled" : ""}`}>
      {isClickable ? (
        <Link to={to}>{content}</Link>
      ) : (
        <span className="home-tile-content">{content}</span>
      )}
    </li>
  );
}

export default HomeTile;
